import styled from "styled-components";
import EmptyCurateImage from "../../../assets/img/OnBoarding/email-browse.png";
import { ReactComponent as CrossIcon } from "../../../assets/img/icons/cross.svg";
import Plus from "../../../assets/img/icons/plus-5.svg";

const EmptyCurate: React.FC = (props: any) => {
  return (
    <Wrapper>
      {/* <div className="header-section margin-top-xl">
        <CrossIcon className="close-sidebar"></CrossIcon>
        <div className="second-row padding-bottom-xl padding-bottom-tab-xl">
          <h4>
            Email <br /> builder
          </h4>
        </div>
      </div> */}
      <div className="empty-curate-wrapper">
        <div className="curate-info-box">
          <div className="curate-info-inner">
            <img alt="" src={EmptyCurateImage} />
            <h4>Introducing the Email builder</h4>
            {/* <p>This is where you will find all your email assets, most-recently modified first.</p> */}
            <p>
              Simply <span className="green">drag and drop</span> your selected content from the Content explorer
              to any email asset below to curate your content, design your email, and publish to your audience.
            </p>
          </div>
          {/* <div className="bottom-notice">Hover dragged articles over here to dismiss…</div> */}
        </div>
        <h3 className="curate-lable">Try creating your first Email asset now:</h3>
        {/* <div className="drop-box">
          <img src={Plus} />
          Drop here to create a new Email asset…
        </div> */}
      </div>
    </Wrapper>
  );
};

export default EmptyCurate;

const Wrapper = styled.div`
  /* position: relative;
  padding-right: 30px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-right: 15px !important;
  }
  .close-sidebar {
    position: absolute;
    right: 25px;
    top: 25px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      right: 18px;
      top: 18px;
      width: 23px;
      height: 23px;
    }
  } */
  .empty-curate-wrapper {
    /* padding-right: 30px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding-right: 15px;
    } */
    /* overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    /* &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    } */
    /* Handle */
    /* &::-webkit-scrollbar-thumb {
      background: #001760;
    } */
    /* Handle on hover */
    /* &::-webkit-scrollbar-thumb:hover {
      background: #efefef;
    } */
    .curate-info-box {
      border: 1px solid rgba(39, 206, 10, 0.26);
      border-radius: 10px;
      /* margin-bottom: 35px; */
      .curate-info-inner {
        padding: 35px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding: 25px;
          border-radius: 7px;
        }
        img {
          width: 100%;
          padding: 15px 0 25px 0;
        }
        h4 {
          color: #27ce0a;
          font-size: 24px;
          font-family: "Roboto Slab";
          font-weight: 400;
          line-height: 36px;
          letter-spacing: -0.4px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 17px;
          }
        }
        p {
          color: #5e7079;
          font-size: 16px;
          font-family: "Roboto";
          letter-spacing: -0.44px;
          line-height: 20px;
          font-weight: 400;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 12px;
          }
          .green {
            color: #27ce0a;
          }
        }
      }
      .bottom-notice {
        color: #27ce0a;
        font-family: "Roboto";
        font-weight: 500;
        padding: 10px 0;
        text-align: center;
        background-color: rgba(39, 206, 10, 0.12);
        border-radius: 0 0 10px 10px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
          border-radius: 0 0 7px 7px;
        }
      }
    }
    .curate-lable {
      color: #67696a;
      font-size: 18px;
      font-family: "Roboto";
      font-weight: 500;
      margin: 25px 0 10px 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
      }
    }
    .drop-box {
      background-color: rgba(39, 206, 10, 0.1);
      color: rgb(39, 206, 10);
      font-family: "Roboto";
      font-weight: 500;
      font-size: 20px;
      padding: 10px 20px;
      border-radius: 10px;
      letter-spacing: -0.5px;
      margin-bottom: 50px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 14px;
        border-radius: 7px;
      }
      img {
        padding-right: 10px;
        margin-top: -3px;
        width: 22px;
      }
    }
  }
`;
